var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "control" }, [
    _c("div", { staticClass: "form-group" }, [
      _c(
        "select",
        {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.selectedValues,
              expression: "selectedValues"
            }
          ],
          staticClass: "form-control selectpicker",
          attrs: {
            title: _vm.parent.placeholder,
            id: "form-" + _vm.parent.specification,
            multiple: ""
          },
          on: {
            change: [
              function($event) {
                var $$selectedVal = Array.prototype.filter
                  .call($event.target.options, function(o) {
                    return o.selected
                  })
                  .map(function(o) {
                    var val = "_value" in o ? o._value : o.value
                    return val
                  })
                _vm.selectedValues = $event.target.multiple
                  ? $$selectedVal
                  : $$selectedVal[0]
              },
              function($event) {
                return _vm.updateFilters(_vm.checkbox, $event)
              }
            ]
          }
        },
        _vm._l(_vm.checkboxes, function(checkbox, index) {
          return _c("option", { domProps: { value: checkbox.value } }, [
            _vm._v("\n\t\t\t\t" + _vm._s(checkbox.label) + "\n\t\t\t")
          ])
        }),
        0
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }